module.exports = __webpack_public_path__ + "img/green-carpet-grass-08.f15cb3b2.png";